module.exports = __webpack_public_path__ + "img/interiorDesign.6327ffa1.svg";